/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mentorexchangefrequency2Inputs */

const en__field_mentorexchangefrequency2 = /** @type {(inputs: _Field_Mentorexchangefrequency2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How frequent to you want to meet with you mentor`)
};

const de__field_mentorexchangefrequency2 = /** @type {(inputs: _Field_Mentorexchangefrequency2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft möchtest du dich mit deinem Mentor/ deiner Mentorin austauschen?`)
};

/**
* | output |
* | --- |
* | "How frequent to you want to meet with you mentor" |
*
* @param {_Field_Mentorexchangefrequency2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_mentorexchangefrequency2 = /** @type {((inputs?: _Field_Mentorexchangefrequency2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mentorexchangefrequency2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentorexchangefrequency2(inputs)
	return de__field_mentorexchangefrequency2(inputs)
});
export { _field_mentorexchangefrequency2 as "_field_mentorExchangeFrequency" }